import React, { useEffect, useState } from 'react';
import { Route, Redirect } from "react-router-dom";
import {publicRoutesPath} from './index';
import PublicLayout from '../Components/Layout/PublicLayout';
import LoginPage from '../Pages/Login';
import ForgotPassword from '../Pages/ForgotPassword';
import { privateRoutesPath } from './index';
import { useDispatch, useSelector } from 'react-redux';
import { requestgetcurrenctuser } from '../Store/User/action';
import FisrtUserPasswordSetup from '../Pages/PasswordSetUp';

const PublicRoute = (props) => {

    const accessToken =  localStorage.getItem('accessToken');

    const [defaultSelectedRoutes, setSelectedDefaultRoutes] = useState("");

    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    
    const dispatch = useDispatch();
    
    const token = localStorage.getItem('accessToken');

    useEffect(() => {
        if(accessToken) {
            dispatch(requestgetcurrenctuser(token));
        }
      },[accessToken])

    useEffect(() => {
        renderSpecificRoutes();
    },[specificRolePermission])

    const renderSpecificRoutes = () => {
        //   if(specificRolePermission?.isConfigurationView) {
            setSelectedDefaultRoutes(privateRoutesPath.DASHBOARD);
            return true;
        //   }

    }


    return (
        <>
            <PublicLayout location={props.location}>
                    {accessToken ? (
                        <Redirect to={defaultSelectedRoutes} />
                    ) : ( <Route exact path={publicRoutesPath.LOGIN} component={LoginPage} />
                      
                    )}
                    <Route exact path = {`${publicRoutesPath?.FIRST_USER_PASSWORD_SETUP}`} component = {FisrtUserPasswordSetup} />
                    <Route exact path={publicRoutesPath.FORGOTPASSWORD} component={ForgotPassword} />
            </PublicLayout>
        </>
    )
}

export default PublicRoute;